import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc0868b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"logo\" style=\"position:relative;text-align:center;\" data-v-bc0868b0><div id=\"logo\" style=\"position:relative;\" data-v-bc0868b0><a href=\"#hero\" data-v-bc0868b0>D</a><div id=\"logo\" style=\"position:absolute;top:0;width:100%;left:-2px;\" data-v-bc0868b0><a href=\"#hero\" data-v-bc0868b0>K</a></div></div></div>", 1)
const _hoisted_2 = { class: "nav-links" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#about-me" }, "About Me", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#project" }, "Projects", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#contact" }, "Contact Me", -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "dropdown-nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", {
      class: _normalizeClass(["navContainer", { 'mini-nav' : _ctx.miniNav} ])
    }, [
      _hoisted_1,
      _withDirectives(_createElementVNode("ul", _hoisted_2, _hoisted_6, 512), [
        [_vShow, !_ctx.mobile]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("i", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args))),
          class: _normalizeClass(["fa fa-bars", {'icon-active': _ctx.mobileNav}])
        }, null, 2), [
          [_vShow, _ctx.mobile]
        ])
      ]),
      _createVNode(_Transition, { name: "mobile-nav" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("ul", _hoisted_8, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args))),
              class: "mobileLink",
              href: "#about-me"
            }, "About Me"),
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args))),
              class: "mobileLink",
              href: "#project"
            }, "Projects"),
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args))),
              class: "mobileLink",
              href: "#contact"
            }, "Contact Me")
          ], 512), [
            [_vShow, _ctx.mobileNav]
          ])
        ]),
        _: 1
      })
    ], 2)
  ]))
}